import { makeContextModule } from '@cian/react-utils';

import { IAppContext } from 'shared/common/types/applicationContext';

export const {
  Context: ApplicationContext,
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IAppContext>({
  contextName: 'ApplicationContext',
});
